import { createApp } from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {
  Radio,
  Spin,
  Col,
  Row,
  Popconfirm,
  Form,
  Divider,
  Button,
  Layout,
  Drawer,
  Menu,
  Avatar,
  Dropdown,
  Input,
  Popover,
  Upload,
  Pagination,
  Select,
  Checkbox,
  Modal,
  Tag,
  Table,
  AutoComplete,
  Card,
  DatePicker,
  Steps,
} from 'ant-design-vue'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import Vue3TouchEvents from 'vue3-touch-events'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import './mixins.scss'
import Camera from 'simple-vue-camera'

createApp(App)
  .use(store)
  .use(router)
  .use(Radio)
  .use(DatePicker)
  .use(Col)
  .use(Spin)
  .use(Steps)
  .use(Row)
  .use(AutoComplete)
  .use(Pagination)
  .use(Popconfirm)
  .use(Form)
  .use(Divider)
  .use(Button)
  .use(Layout)
  .use(Drawer)
  .use(Menu)
  .use(Avatar)
  .use(Dropdown)
  .use(Input)
  .use(Popover)
  .use(Upload)
  .use(Select)
  .use(Checkbox)
  .use(Modal)
  .use(Tag)
  .use(Table)
  .use(Card)
  .use(PerfectScrollbar)
  .use(Vue3TouchEvents)
  .use(Vue3TouchEvents, {
    disableClick: true, // Opsional, disable jika tidak ingin click events terpengaruh
    swipeTolerance: 100, // Ambang batas panjang swipe, opsional tapi bisa diatur
  })
  .component('camera', Camera)
  .component(VueQrcode.name, VueQrcode)
  .mount('#app')
